import { Children, ReactNode } from 'react';
import { isFragment } from 'react-is';

const countNonEmptyChildren = (children?: Array<ReactNode> | ReactNode) => {
    let total = 0;

    if (!children) {
        return 0;
    }

    if (!Array.isArray(children)) {
        return 1;
    }

    children.forEach((child) => {
        if (!child) {
            return;
        }

        if (isFragment(child)) {
            total += countNonEmptyChildren(
                Children.toArray(child.props.children)
            );
        } else {
            total++;
        }
    });

    return total;
};

export default countNonEmptyChildren;
